import { provideLocal } from '@vueuse/core';
import { PRODUCT_ID_REPOSITORY } from '../constants/providers';

/**
 * * Product Id Provider
 * ! Dependency Injection of product id
 */
export const useProductIdProvide = (productId: ProductId) => {
  provideLocal(PRODUCT_ID_REPOSITORY, productId);
};
